// Required profile details (title, country, nationality, phone, position, organization).
// Members who sign in with a social account fill these in before using the portal.
const API_BASE_URL = 'https://emiratesscholar.com/system/api';

// Set after a social sign-in that still needs these details; the protected routes send the
// member to /complete-profile until it is cleared.
export const PROFILE_INCOMPLETE_KEY = 'profile_incomplete';

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
  Accept: 'application/json',
});

export const fetchProfileCompletion = async () => {
  const res = await fetch(`${API_BASE_URL}/profile-completion`, { headers: headers() });
  if (!res.ok) throw new Error(`Profile check failed (${res.status})`);
  return res.json();
};

export const saveProfileCompletion = async (form) => {
  const res = await fetch(`${API_BASE_URL}/complete-profile`, {
    method: 'POST',
    headers: { ...headers(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || `Could not save your details (${res.status})`);
    err.errors = json.errors;
    throw err;
  }
  return json;
};
